import { render, staticRenderFns } from "./WizardProvider.vue?vue&type=template&id=33163dbc&scoped=true"
import script from "./WizardProvider.vue?vue&type=script&lang=js"
export * from "./WizardProvider.vue?vue&type=script&lang=js"
import style0 from "./WizardProvider.vue?vue&type=style&index=0&id=33163dbc&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33163dbc",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Providers/WizardProvider.vue
// module id = 2500
// module chunks = 31